import React, { cloneElement } from "react";
import PropTypes from "prop-types";

function When({ condition, children, ...props }) {
  if (!condition) {
    return null;
  }

  const component = cloneElement(children(), props);
  return <>{component}</>;
}

When.propTypes = {
  condition: PropTypes.bool,
  children: PropTypes.func,
};

When.defaultProps = {
  condition: false,
  children: () => null,
};

export default When;
